import AutoCompleteWithInput from "../../../../Components/Inputs/AutoCompleteWithText";
import ProTextInput from "../../../../Components/Inputs/TextField";
import ProSelectInput from "../../../../Components/Inputs/SelectField"
import FormSectionWrapper from "../../../../Components/ProForms/FormSectionWrapper";
import WageDocumentsUpload from "../../../../Components/WageDetermination/Wagedocumentsupload";
import { Grid, Stack } from "@mui/material";

const ProjectNameAndAddressSection = ({
  defaultFormProps,
  formConfig,
  permissions,
  isAddMode,
  enverusProjects,
  fetchEnverusProjects,
  AddNewProjectName,
  handleChangeInProjectSelect,
  allStates,
  zipOptions,
  countyOptions,
  cityOptions,
  loadingZip,
  loadingCounty,
  loadingCity,
  makeFieldAndDependentsEditable,
  wageDocumentsFiles = [],
  onWageDocumentAdd,
  onWageDocumentLabelChange,
  onWageDocumentDelete
}) => {
  const fieldPermission = key => permissions.fieldPerObj[formConfig[key].perKey];
  const isEditMode = formConfig.wageDeterminationNumber?.mode === "edit";


  // define the form fields with metadata
  const fields = [
    {
      type: "autoComplete",
      key: "projectName",
      extraProps: {
        onBlur: AddNewProjectName,
        fetchOptions: fetchEnverusProjects,
        options: enverusProjects,
        renderTextOnly: !isAddMode,
        handleSelect: handleChangeInProjectSelect,
      },
    },
    { type: "text", key: "internalProjectId" },
    { type: "text", key: "address1" },
    { type: "text", key: "address2" },
    {
      type: "select",
      key: "state",
      options: allStates,
    },
    {
      type: "select",
      key: "zipCode",
      options: zipOptions,
      loading: loadingZip,
    },
    {
      type: "select",
      key: "primaryCounties",
      options: countyOptions,
      loading: loadingCounty,
    },
    {
      type: "select",
      key: "city",
      options: cityOptions,
      loading: loadingCity,
      extraProps: { allowManualEntry: true },
    },
    { type: "text", key: "country" },
    { type: "text", key: "nercRegion" },
    { type: "text", key: "isoTerritory" },
    { type: "text", key: "lat" },
    { type: "text", key: "long" },
  ];

  const renderField = field => {
    const config = formConfig[field.key];
    const permission = fieldPermission(field.key);

    const commonProps = {
      ...defaultFormProps,
      ...config,
      permission,
      ...(field.extraProps || {}),
    };

    if (field.type === "autoComplete") {
      return <AutoCompleteWithInput key={field.key} {...commonProps} />;
    }

    if (field.type === "select") {
      return (
        <ProSelectInput
          key={field.key}
          {...commonProps}
          options={field.options}
          loading={field.loading}
          handleReadValueClick={name =>
            makeFieldAndDependentsEditable(name, field.key)
          }
          fieldProps={{
            ...config.fieldProps,
            onFocus: () =>
              makeFieldAndDependentsEditable(field.key, field.key),
          }}
        />
      );
    }

    // default = text input
    return <ProTextInput key={field.key} {...commonProps} />;
  };

  return (
    permissions.canView && (
      <FormSectionWrapper collapsible title="Project Name & Address">
        {fields.map(renderField)}
        <Grid item xs={12} md={8}>
          <Stack direction="row" spacing={1} alignItems="center">
            <ProTextInput
              {...defaultFormProps}
              {...formConfig.wageDeterminationNumber}
              permission={fieldPermission("wageDeterminationNumber")}
              sx={{ flex: 1 }}
            />

            <WageDocumentsUpload
              files={wageDocumentsFiles}
              onAddFile={onWageDocumentAdd}
              onLabelChange={onWageDocumentLabelChange}
              onDeleteFile={onWageDocumentDelete}
              disabled={!isEditMode}
            />
          </Stack>
        </Grid>
      </FormSectionWrapper>
    )
  );
};

export default ProjectNameAndAddressSection;